module.exports = __webpack_public_path__ + "static/img/23.28acac36.png";